// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4283":"d4fee2f5","9925":"5c3e3b2a"}[chunkId] + ".chunk.css";
};